import styled from "@emotion/styled";
import {
  GelColumnLayout,
  GelContainerLite,
  GelModal,
  GelParagraph,
  GelSpinner,
} from "@tal-gel/components";
import { getGelTokens } from "@tal-gel/theming";
import ModuleContainer from "components/components/ModuleContainer";
import AboutSkinCancer from "components/templates/AboutSkinCancer";
import EarlyDetection from "components/templates/EarlyDetection";
import PreventSkinCancer from "components/templates/PreventSkinCancer";
import React from "react";
import ProductCard from "../../components/ProductCard";

const cards = [
    {
        title: "About skin cancer",
        imageUrl: "/images/about-skin-cancer.jpg",
        description: "Learn about the different types of skin cancer and how it is caused.",
        content: <AboutSkinCancer />,
    },
    {
        title: "Prevent skin cancer",
        description:
            "Skin cancer can be prevented by protecting your skin and minimising your sun exposure.",
        content: <PreventSkinCancer />,
    },
    {
        title: "Detect skin cancer",
        description:
            "Checking your skin regularly can help maximise the chances of detecting skin cancer early.",
        content: <EarlyDetection />,
    },
    {
        title: "Speak to your local GP*",
        description:
            "Book in with your GP to talk about your risk level of skin cancer and any next steps.",
        externalLink: "https://www.healthdirect.gov.au/australian-health-services",
    },
];

function HomeDescription() {
  const [openModal, setOpenModal] = React.useState(false);
  const [active, setActive] = React.useState(0);

  const onOpen = (value) => {
    setActive(value);
    setOpenModal(true);
  };

  return (
    <ModuleContainer>
      <GelContainerLite fixed>
        <SParagraphContainer>
          <GelParagraph textAlign="center">
            Now in its ninth year, TAL SpotChecker has been educating Australians about the importance of sun safety by encouraging conversations about the benefits of embracing secondary prevention, and the importance of both regularly self-checking followed by a professional skin check-up when there is a concern. Skin cancer is one of the most preventable and detectable cancers. Simple habits like checking the UV, sunscreen, covering up when the UV is 3 and above, and monthly skin checks - could greatly reduce your risk.
          </GelParagraph>
        </SParagraphContainer>
      </GelContainerLite>
      <GelContainerLite fixed>
              <GelColumnLayout distribution="1/4 1/4 1/4 1/4" gutter="medium">
                  {cards.map((card, i) => (
                      <ProductCard
                          key={i}
                          backgroundColor={getGelTokens().global.themeColorBackgroundLight}
                          color={getGelTokens().brand.brandColorPrimary1T70}
                          title={card.title}
                          description={card.description}
                          onClick={() => {
                              if (card.externalLink) {
                                  window.open(card.externalLink, "_blank");
                              } else {
                                  onOpen(i);
                              }
                          }}
                          icon={card.externalLink ? "ExternalLink" : "Plus"}
                      />
                  ))}
              </GelColumnLayout>
      </GelContainerLite>

      <SModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        width="lg"
        title={cards[active].title}
      >
        {cards[active].content}
      </SModal>
    </ModuleContainer>
  );
}

export default HomeDescription;

const SParagraphContainer = styled.div({
  paddingBottom: 40,
  display: "flex",
  flexDirection: "column",
  gap: 24,
});

const SModal = styled(GelModal)`
  [data-cy="gel-modal-heading-container"] {
    background-color: ${getGelTokens().global.themeColorBackgroundInverse};
    color: white;
  }

  [data-cy="gel-modal-container"] {
    background-color: ${getGelTokens().global.themeColorBackgroundInverse};
  }

  > div:nth-of-type(1) {
    background-color: ${getGelTokens().global.themeColorBackgroundInverse};
  }
`;
